// src/redux/slices/clientSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ApiGetClientDbName } from '../../../apiService/Core/Apicall';

// Define the Client type (adjust based on your API response)
export interface Client {
  id: string;
  name: string;
  // add other properties if available
}

// State type
interface ClientState {
  clientList: any;
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: ClientState = {
  clientList: [],
  loading: false,
  error: null,
};

// Async thunk
export const fetchClientList = createAsyncThunk<Client[]>(
  'client/fetchClientList',
  async () => {
    const response = await ApiGetClientDbName();
    return response.data;
  }
);

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientList.fulfilled, (state, action: PayloadAction<Client[]>) => {
        state.clientList = action.payload;
        state.loading = false;
      })
      .addCase(fetchClientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Something went wrong';
      });
  },
});

export default clientSlice.reducer;
